module.exports = __webpack_public_path__ + "img/stage6.849e5450.png";